import { render, staticRenderFns } from "./SCRM.vue?vue&type=template&id=3c842e9d&scoped=true&"
import script from "./SCRM.vue?vue&type=script&lang=js&"
export * from "./SCRM.vue?vue&type=script&lang=js&"
import style0 from "./SCRM.vue?vue&type=style&index=0&id=3c842e9d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c842e9d",
  null
  
)

export default component.exports